import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=6127a1af&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=ts&"
export * from "./DynamicForm.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=6127a1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127a1af",
  null
  
)

export default component.exports